import { render, staticRenderFns } from "./operatioRecords.vue?vue&type=template&id=3883c274&scoped=true&"
import script from "./operatioRecords.vue?vue&type=script&lang=js&"
export * from "./operatioRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3883c274",
  null
  
)

export default component.exports